import { Box, IconButton } from "@mui/material";
import React, { useEffect } from "react";
import colors from "../../../shared/themes/colors";
import Moment from "react-moment";
import { formatFileSize } from "../../../shared/models/models";
import OverflowTooltip from "../../../shared/components/OverflowTooltip";
import DownloadIcon from "../../../shared/assets/icons/DownloadIcon";
import { downloadFile } from "../../../shared/utils/fileUtils";
import { useAppDispatch, useAppSelector } from "../../../shared/hooks/sharedHooks";
import { PublicState, getDocuments, getMachine } from "../../publicSlice";
import { useParams } from "react-router-dom";
import Loader from "../../../shared/components/Loader";
import useTranslation from "../../../shared/hooks/useTranslation";
import { localizeDateFormat } from "../../v2/shared/dateFormat";
import KioskBackButton from "../kiosk/KioskBackButton";

const DocumentsPage = () => {
  const { documents, machine, loading } = useAppSelector<PublicState>((state: any) => state.public);
  const dispatch = useAppDispatch();

  const { id } = useParams();
  const { translate, i18n } = useTranslation("public");

  useEffect(() => {
    if (id) {
      dispatch(getMachine(id));
    }
  }, [id]);

  useEffect(() => {
    if (machine?.internalNumber) {
      dispatch(getDocuments(machine.internalNumber));
    }
  }, [machine]);

  if (loading) {
    return <Loader />
  }

  return (
    <Box className="flex flex-col gap-6" sx={{ px: 2, pb: "80px" }}>
      <Box className="heading-2">{translate("manualsAndSoftware")}</Box>

      <Box className="flex flex-col gap-4">
        {documents?.map((document) => (
          <Box
            key={document.id}
            className="flex justify-between items-center w-full p-4"
            sx={{
              background: colors.secondary.gray98,
              borderRadius: "4px",
              border: `1px solid ${colors.secondary.gray90}`
            }}
          >
            <Box className="flex justify-between items-start w-full">
              <Box className="flex flex-col gap-2 md:flex md:flex-row md:items-center md:gap-6">
                <Box className="text-14-medium" color="#333333">
                  {document.name}
                </Box>

                <Box className="flex gap-2">
                  <Box className="text-12-regular" color="#333333">
                    <Moment date={document.createdDate} format={localizeDateFormat("DD.MM.YYYY, HH:mm", i18n.language)} />
                  </Box>

                  {document.file && (
                    <Box className="flex gap-2">
                      <Box sx={{ maxWidth: "70px" }}>
                        <OverflowTooltip
                          text={document.file.name}
                          className="text-12-regular"
                          color={colors.secondary.gray40}
                        />
                      </Box>
                      <Box className="text-12-regular" color="#7A8093">
                        {formatFileSize(document.file.size)}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>

              <IconButton onClick={() => downloadFile(document.file!.content, document.file!.name)} sx={{ p: 0 }}>
                <DownloadIcon width="18px" height="18px" />
              </IconButton>
            </Box>
          </Box>
        ))}
      </Box>

      <KioskBackButton />
    </Box>
  );
};

export default DocumentsPage;